
// Auto-expand all collection filters
document.addEventListener('DOMContentLoaded', function() {
  // Function to expand all filters
  function expandAllFilters() {
    const filterHeaders = document.querySelectorAll('.filter .filter-name:not(.active)');
    
    if (filterHeaders.length > 0) {
      filterHeaders.forEach(function(header) {
        // Check if the filter has options to show
        const filterContainer = header.closest('.filter');
        const filterList = filterContainer.querySelector('ul');
        
        if (filterList && filterList.children.length > 0) {
          header.click();
        }
      });
    }
  }
  
  // Only run on collection/search pages
  if (window.location.href.indexOf('collections') > -1 || 
      window.location.href.indexOf('search') > -1) {
    
    // Wait for Vue to initialize and render filters
    setTimeout(function() {
      expandAllFilters();
    }, 1000);
    
    // Also run after any filter interactions (in case filters get rebuilt)
    const categoryApp = document.getElementById('category-app') || document.getElementById('search-app');
    if (categoryApp) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && 
              mutation.target.classList.contains('filters-inner')) {
            setTimeout(expandAllFilters, 100);
          }
        });
      });
      
      observer.observe(categoryApp, {
        childList: true,
        subtree: true
      });
    }
  }
});